import { css } from "@emotion/react";

export const styles = {
  hotizontal_line: css`
    background-image: linear-gradient(to right, white 40%, #0045b5 0%);
    background-position: top;
    background-size: 16px 3px;
    background-repeat: repeat-x;
    width: 100vw;
    height: 3px;
    position: absolute;
    bottom: 0px;
    left: 438px;
  `,
  vertical_line: css`
    background-image: linear-gradient(to top, white 40%, #0045b5 0%);
    background-position: top;
    background-size: 3px 16px;
    background-repeat: repeat-y;
    width: 3px;
    height: 100%;
    position: absolute;
    bottom: 0;
    right: -1px;
  `,
  vertical_line_right: css`
    background-image: linear-gradient(to top, white 40%, #0045b5 0%);
    background-position: top;
    background-size: 3px 16px;
    background-repeat: repeat-y;
    width: 3px;
    height: 100%;
    position: absolute;
    bottom: 0;
    left: -1px;
    top: 8px;
  `
};
